import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { DataListHeader, DataListRow, Panel } from 'mailup-web-components'

import { resultsState } from 'Pages/AbTestList/recoil/state/results'
import Result from './Result'

const Results = () => {
  const intl = useIntl()

  const { items } = useRecoilValue(resultsState)

  const heads = [
    {
      label: intl.formatMessage({ id: 'Load.ABTestList.TableHeaderABtest' }),
      span: 3,
      sortable: false
    },
    {
      label: intl.formatMessage({ id: 'Load.AbTest.SelectedMessages' }),
      span: 6,
      sortable: false
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Status' }),
      span: 3,
      sortable: false
    }
  ]
  return (
    <>
      <Panel>
        <DataListHeader heads={heads} afterWidth='26px' />
        <div>
          {items.map(
            ({ Info, Messages, aggregateReport, recoverable }, index) => (
              <DataListRow key={index}>
                <Result
                  info={Info}
                  messages={Messages.filter(e => e.messageOk)}
                  aggregateReport={aggregateReport}
                  recoverable={recoverable}
                />
              </DataListRow>
            )
          )}
        </div>
      </Panel>
    </>
  )
}

export default Results
